import {setMemberProfile} from "../store/member/actions";
import { getRegionalsData } from "../store/regionals/actions";
import MemberService from "../services/HumanResources/MemberService";
import RegionalService from "../services/Global/RegionalService";
import ObserverService from "../services/Election/ObserverService";
import { getObserver } from "../store/actions";


export const LoadMemberProfile = (token, dispatchRedux) => {
    MemberService.geMyProfileAccesses(token)
    .then((response) => {
        const profileData = response.data;
        const action = setMemberProfile(profileData);
        dispatchRedux(action);
    })
    .catch((err) => {
    });
}

export const LoadRegionalData = (token, dispatchRedux) => {
    RegionalService.geRegionalData(token)
    .then((response) => {
        const regionalsData = response.data;
        const action = getRegionalsData(regionalsData);
        dispatchRedux(action);
    })
    .catch((err) => {
    });
}

export const LoadObserverData = (dispatchRedux) => {
    ObserverService.getList()
    .then((response) => {
        const responseData = response.data;
        const action = getObserver(responseData);
        dispatchRedux(action);
    })
    .catch((err) => {
    });
}